// hooks/use-payment-channel.ts
import { QUERY_KEY } from "@/constant/queryKey";
import {
  adminPaymentChannelApi,
  AdminPaymentChannelDto,
} from "@/services/core/payment-channel.api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
// Hook for creating a payment channel
export function useCreatePaymentChannel() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: AdminPaymentChannelDto) =>
      adminPaymentChannelApi.create(data),
    onSuccess: () => {
      // Invalidate the payment channels list query to refetch data
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY.PAYMENT_CHANNELS] });
    },
  });
}

// Hook for updating a payment channel
export function useUpdatePaymentChannel() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: AdminPaymentChannelDto }) =>
      adminPaymentChannelApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY.PAYMENT_CHANNELS] });
    },
  });
}

// Hook for deleting a payment channel
export function useDeletePaymentChannel() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => adminPaymentChannelApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY.PAYMENT_CHANNELS] });
    },
  });
}

// Hook for toggling payment channel active status
export function useTogglePaymentChannelStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, active }: { id: number; active: boolean }) =>
      adminPaymentChannelApi.toggleActive(id, active),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY.PAYMENT_CHANNELS] });
    },
  });
}
